<button [id]="id" [title]="title || text" (click)="onClickHandler($event)" [disabled]="disabled" [ngClass]="classes">
    <sc-icon *ngIf="prefixIcon || loading" class="sc-button__icon" [icon]="(loading) ? 'loading' : prefixIcon"></sc-icon>
    <span *ngIf="!loading && !iconOnly" class="sc-button__content">
        <span *ngIf="!text">
            <ng-content></ng-content>
        </span>
        <span *ngIf="text">{{text}}</span>
    </span>
    <sc-icon *ngIf="suffixIcon" class="sc-button__icon" [icon]="suffixIcon"></sc-icon>
</button>